import script from "./ProductStock.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductStock.vue?vue&type=script&setup=true&lang=ts"

import "./ProductStock.vue?vue&type=style&index=0&id=fee73172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fee73172"]])

export default __exports__